import React, { useCallback, useState, useEffect } from 'react';
import { eAlertsCoreAPIEndpoint, ENDPOINTS } from '../../api';
import jwt from 'jwt-decode';
import { useHistory } from 'react-router-dom';

export default function ContactInformation(props) {
  let history = useHistory();
  const [userAccount, setUserAccount] = useState([]);
  const token = jwt(localStorage.getItem('token'));
  const accountId = token.id;
  const getContactInformation = useCallback(async () => {
    await eAlertsCoreAPIEndpoint(ENDPOINTS.ACCOUNT)
      .getById(accountId)
      .then((response) => {
        setUserAccount(response.data);
      })
      .catch(() => {
        if (!window.location.hash) {
          window.location = window.location + '#loaded';
          window.location.reload();
        } else {
          history.push('/login');
        }
      });
  }, [accountId, history]);

  useEffect(() => {
    getContactInformation();
  }, [getContactInformation]);
  return (
    <>
      <br />
      <h1>
        {userAccount.firstName} {userAccount.lastName}
      </h1>
      <p className="ce">{userAccount.emailAddress}</p>
    </>
  );
}
